<div class="container-fluid py-3">
    @switch (view().status) {
        @case ('loading') {
            <app-load />
        }
        @case ('notFound') {
            <div class="alert alert-warning" role="alert">
                {{ 'installationProjects_detail_notFound' | translate: 'online' : 'ngonline' }}
            </div>
        }
        @case ('error') {
            <div class="alert alert-danger" role="alert">
                {{ 'installationProjects_error' | translate: 'online' : 'ngonline' }}
            </div>
        }
        @case ('success') {
            <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="fw-bold">
                    {{
                        'installationProjects_detail_tab_locations'
                            | translate: 'online' : 'ngonline'
                    }}
                    <span class="text-muted fw-normal">
                        / {{ rows().length }}
                        {{
                            'installationProjects_locations_countLabel'
                                | translate: 'online' : 'ngonline'
                        }}
                    </span>
                </span>
                <button
                    type="button"
                    class="btn btn-outline-primary"
                    [disabled]="rows().length === 0"
                    (click)="exportLocations()">
                    <i class="bi bi-file-earmark-text me-1" aria-hidden="true"></i>
                    {{ 'installationProjects_export' | translate: 'online' : 'ngonline' }}
                </button>
            </div>

            <div class="table-responsive w-100">
                <table class="table table-striped table-sm align-middle">
                    <thead>
                        <tr>
                            @for (column of columns; track column.column) {
                                <th
                                    app-sortable-table-header
                                    [column]="column.column"
                                    [label]="column.labelKey | translate: 'online' : column.module"
                                    [initialDirection]="
                                        column.column === 'visitDate' ? 'asc' : null
                                    "
                                    (sort)="onSort($event)"></th>
                            }
                        </tr>
                    </thead>
                    <tbody class="text-nowrap">
                        @for (row of rows(); track row.location) {
                            <tr>
                                <td>
                                    @if (row.location.proBraLoc; as proBraLoc) {
                                        {{ proBraLoc }}
                                    } @else {
                                        &ndash;
                                    }
                                </td>
                                <td class="fw-bold">{{ row.address }}</td>
                                <td>
                                    @if (row.location.consumerName; as consumerName) {
                                        {{ consumerName }}
                                    } @else {
                                        &ndash;
                                    }
                                </td>
                                <td>
                                    @if (row.location.email; as email) {
                                        <a [href]="'mailto:' + email">{{ email }}</a>
                                    } @else {
                                        &ndash;
                                    }
                                </td>
                                <td>
                                    @if (row.location.visitDate; as visitDate) {
                                        {{ visitDate | appdate: visitDateFormat }}
                                    } @else {
                                        &ndash;
                                    }
                                </td>
                                <td>
                                    @if (row.timeSlot; as timeSlot) {
                                        {{ timeSlot }}
                                    } @else {
                                        &ndash;
                                    }
                                </td>
                                <td>
                                    <span class="badge" [class]="row.statusDisplay.pillClass">
                                        {{
                                            row.statusDisplay.labelKey
                                                | translate: 'online' : 'ngonline'
                                        }}
                                    </span>
                                </td>
                                <td>{{ row.location.remarks }}</td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="8" class="text-center text-muted py-4">
                                    {{ 'table_noResults' | translate: 'online' : 'common' }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    }
</div>
